<template>
    <section :class="itemClass">
        <template v-if="label">
            <h3 :class="labelClass">
                {{ label }}
            </h3>
        </template>

        <slot></slot>
    </section>
</template>

<script>
    export default {
        props: {
            label: { type: String, default: null },
            width: { type: String, default: 'half' },
            isInline: { type: Boolean, default: false },
            isCompact: { type: Boolean, default: false },
            showColonSymbol: { type: Boolean, default: true },
            isLabelBolded: { type: Boolean, default: false },
        },

        computed: {
            itemClass() {
                return {
                    summary__item: true,
                    [`summary__item--width-${this.width}`]: true,
                    'summary__item--is-inline': this.isInline,
                    'summary__item--is-compact': this.isCompact,
                }
            },
            labelClass() {
                return {
                    summary__label: this.showColonSymbol,
                    'summary__label--no-colon-after': !this.showColonSymbol,
                    'summary__label--bolded': this.isLabelBolded,
                }
            },
        },
    }
</script>
